import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import 'sonner/dist/styles.css'
import './index.css'
import App from './App.tsx'
import { ThemeProvider } from './store/themeStore.tsx'
import { AppearanceSync } from './components/settings/AppearanceSync.tsx'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider>
      <AppearanceSync />
      <App />
    </ThemeProvider>
  </StrictMode>,
)
